import React from 'react';

const VideoAnnotationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    style={{ width: '100%', display: 'block' }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 87 87"
    {...props}
  >
    <g fill="none">
      <rect width="86.6" height="86.6" y=".4" fill={props.color || '#FFBB1A'} rx="43.3" />
      <g fill="#FFFFFF" transform="translate(20 17)">
        <path
          d="M23.5 0L7.83 9 0 13.5v27l15.67 9L23.5 54 47 40.5v-27L23.5 0zm-7.83 40.5v-27L39.17 27l-23.5 13.5z"
          opacity=".5"
        />
        <polygon points="23.596 0 47 13.5 47 22.5 39.202 27 8 9" opacity=".9" />
        <polygon points="46 40.286 22.748 54 15 49.429 15 40.286 46 22" opacity=".5" />
      </g>
    </g>
  </svg>
);

export default VideoAnnotationIcon;
